import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBoardNewRenewal from "../../../../components/CustomBoardNewRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import Color from "../../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomButton from "../../../../components/CustomButton";
import * as selector from "../../../../../common/selectors";
import * as onlineRenewalSelector from "../../../../../common/selectors/onlineRenewal";
import * as onlineRenewalAction from "../../../../../common/actions/onlineRenewal";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import ReactGA from "react-ga";
import CustomRadioButton from "../../../../components/CustomRadioButton";
import Image from "../../../../../assets";
import * as enrolGIRONowSelector from "../../../../../common/selectors/enrolGIRONow";
import * as enrolGIRONowAction from "../../../../../common/actions/enrolGIRONow";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import { check } from "prettier";

const policyInfo = {
  policyNo: "M0001033",
  productName: "Commercial Motor",
  startDate: "31/08/2020",
  endDate: "30/09/2020",
  renewalPremium: "1,343.15",
};

class PolicyInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      localPolicyNo: "",
      localOrderNo: "",
      localNric: "",
      localPremium: "",
      localIsRecurring: false,
      localProduct: "",
      localCoveragePeriod: "",
      localStatusLabel: "",
      localMsg: "",
      checkedA: false,
      localShowRecurringCheckBox: false,
      loadingToReddot: false,
      isCheckCreditCard: true,
      isCheckDebitCard: false,
      localBankList: [],
      bankID: "",
      localOwnerName:"",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const { checkRenewabilityData } = this.props;

    const policyNo = onlineRenewalSelector.checkRenewabilityDataPolicyNumber(
      checkRenewabilityData
    );
    const orderNo = onlineRenewalSelector.checkRenewabilityDataOrderNumber(
      checkRenewabilityData
    );
    const nric = onlineRenewalSelector.checkRenewabilityDataNric(
      checkRenewabilityData
    );
    const premium = onlineRenewalSelector.checkRenewabilityDataPremium(
      checkRenewabilityData
    );
    const isRecurring = onlineRenewalSelector.checkRenewabilityDataIsRecurring(
      checkRenewabilityData
    );
    const product = onlineRenewalSelector.checkRenewabilityDataProduct(
      checkRenewabilityData
    );
    const coveragePeriod = onlineRenewalSelector.checkRenewabilityDataCoveragePeriod(
      checkRenewabilityData
    );
    const statusLabel = onlineRenewalSelector.checkRenewabilityDataStatusLabel(
      checkRenewabilityData
    );
    const msg = onlineRenewalSelector.checkRenewabilityDataMessage(
      checkRenewabilityData
    );
    const showRecurringPaymentCheckBox = onlineRenewalSelector.checkRenewabilityDataShowRecurringPaymentCheckBox(
      checkRenewabilityData
    );

    const isEddaRenewalAllow = onlineRenewalSelector.checkRenewabilityDataIsEddaRenewalAllow(
      checkRenewabilityData
    );
    const ownerN = onlineRenewalSelector.checkRenewabilityDataOwnerName(
      checkRenewabilityData
    );
    
    this.setState({
      localPolicyNo: policyNo,
      localOrderNo: orderNo,
      localNric: nric,
      localPremium: premium,
      localIsRecurring: isRecurring,
      localProduct: product,
      localCoveragePeriod: coveragePeriod,
      localStatusLabel: statusLabel,
      localMsg: msg,
      localShowRecurringCheckBox: showRecurringPaymentCheckBox,
      checkedA: isRecurring,
      localIsEddaAllow:isEddaRenewalAllow,
      localOwnerName:ownerN
    });

    const { getGIROBankList } = this.props;
    getGIROBankList(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidUpdate = (prevProps) => {
    const { history } = this.props;
    const {
      renewalPayNowLoading,
      renewalPayNowData,
      renewalPayNowStatus,
    } = this.props;

    if (prevProps.getGIROBankListData !== this.props.getGIROBankListData) {
      const success = enrolGIRONowSelector.getGIROBankListDataSuccess(
        this.props.getGIROBankListData
      );
      const data = enrolGIRONowSelector.getGIROBankListDataData(
        this.props.getGIROBankListData
      );
      if (success === true) {
        //console.log("data", data);
        this.setState({ localBankList: data });
      }
    }

    if (prevProps.createEDDAData !== this.props.createEDDAData) {
      const eddaData = enrolGIRONowSelector.createEDDADataData(
        this.props.createEDDAData
      );
      const dataInside = enrolGIRONowSelector.createEDDADataDataInside(
        eddaData
      );
      const success = enrolGIRONowSelector.createEDDADataSuccess(
        this.props.createEDDAData
      );

      const errorCode = enrolGIRONowSelector.createEDDADataDataInsideErrorCode(
        eddaData
      );
      const errorMsg = enrolGIRONowSelector.createEDDADataDataInsideErrorMsg(
        eddaData
      );
      if (success === false) {
        this.setState({ error: true, errorMsg: dataInside });
        //console.log("errorCode",this.props.createEDDAData.Data.Error_Message)

        const { history } = this.props;
        console.log("errorCode", errorMsg);
        history.push(
          "/GiroStatus" +
            "?" +
            "status=" +
            "failed" +
            "&" +
            "ErrorCode=" +
            this.props.createEDDAData.Data.Error_Code +
            "&" +
            "ErrorMessage=" +
            this.props.createEDDAData.Data.Error_Message
        );
      } else {
        const result = enrolGIRONowSelector.createEDDADataResult(eddaData);
        this.setState({ redirectLoading: true });
        //console.log("dataInside",result)
        if(result === null){
          const { history } = this.props;
          console.log("errorCode", errorMsg);
          history.push(
            "/GiroStatus" +
              "?" +
              "status=" +
              "failed" +
              "&" +
              "ErrorCode=" +
              this.props.createEDDAData.Data.Error_Code +
              "&" +
              "ErrorMessage=" +
              this.props.createEDDAData.Data.Error_Message
          );
        }else{
          window.location.href = result;
        }
       
      }
    }

    if (
      renewalPayNowLoading === false &&
      renewalPayNowData !== null &&
      renewalPayNowStatus === true
    ) {
      const paymentModel = onlineRenewalSelector.renewalPayNowDataPaymentModel(
        renewalPayNowData.Data
      );
      const amount = onlineRenewalSelector.renewalPayNowDataAmount(
        paymentModel
      );
      const email = onlineRenewalSelector.renewalPayNowDataEmail(paymentModel);
      const apiName = onlineRenewalSelector.renewalPayNowDataAPIName(
        paymentModel
      );
      const key = onlineRenewalSelector.renewalPayNowDataKey(paymentModel);
      const payMode = onlineRenewalSelector.renewalPayNowDataPayMode(
        paymentModel
      );
      const notifyURL = onlineRenewalSelector.renewalPayNowDataNotifyURL(
        paymentModel
      );
      const txnID = onlineRenewalSelector.renewalPayNowDataTxnId(paymentModel);
      const isRecurring = onlineRenewalSelector.renewalPayNowDataIsRecurring(
        paymentModel
      );
      const statusLabel = onlineRenewalSelector.checkRenewabilityDataStatusLabel(
        renewalPayNowData.Data
      );
      const paymentUrl = onlineRenewalSelector.renewalPayNowDataPaymentUrl(
        renewalPayNowData.Data
      );
      const returnUrl = onlineRenewalSelector.renewalPayNowDataReturnURL(
        paymentModel
      );

      if (statusLabel === "Renewal Unsuccessful") {
        history.push("/PayRenewalUnsuccessful");
      } else {
        let form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", paymentUrl);
        let field = [
          { name: "amount", value: amount },
          { name: "email", value: email },
          { name: "APIName", value: apiName },
          {
            name: "key",
            value: key,
          },
          { name: "payMode", value: payMode },
          {
            name: "returnURL",
            value: returnUrl,
          },
          { name: "notifyURL", value: notifyURL },
          { name: "txnId", value: txnID },
          { name: "isRecurring", value: isRecurring },
        ];
        for (let i = 0; i < field.length; i++) {
          let hf = document.createElement("input");
          hf.setAttribute("type", "hidden");
          hf.setAttribute("name", field[i].name);
          hf.setAttribute("value", field[i].value);
          form.appendChild(hf);
        }
        document.body.appendChild(form);
        form.submit();
        this.setState({ loadingToReddot: true });
      }
    }
  };

  onClickPayRenewal = () => {
    const { renewalPayNow } = this.props;

    const {
      localPremium,

      localOrderNo,
      localNric,
      localPolicyNo,
      checkedA,
    } = this.state;

    //console.log("checkedA",checkedA)

    if (localPremium === "$0.00") {
      window.history.back();
    } else {
      renewalPayNow(
        localPremium,
        localOrderNo,
        localNric,
        localPolicyNo,
        checkedA
      );
    }
  };

  onClickLetGo = () => {
    ReactGA.event({
      category: "Renewal",
      action: "Redirecting to Red dot to make Payment",
    });
    if(this.state.isCheckCreditCard){
      this.onClickPayRenewal();
    }
    if(this.state.isCheckDebitCard){
      this.onClickDirectDebit();
    }
    
  };

  onClickDirectDebit = () => {
    //this.onClickPayRenewal();
    const { createEDDA } = this.props;
    const {
      localPolicyNo,
      localProduct,
      localPremium,
      bankID,
      localOrderNo,
      checkedA,
      checkedTerms,
    } = this.state;
    if (this.state.bankID === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "You must select your preferred bank for GIRO enrolment.",
      });
      return;
    }

    if (this.state.bankID === 0) {
      this.setState({
        customToastStatus: true,
        toastMessage: "You must select your preferred bank for GIRO enrolment.",
      });
      return;
    }

    // if (checkedTerms === false) {
    //   this.setState({
    //     customToastStatus: true,
    //     toastMessage: "Please check the Terms and Conditions.",
    //   });
    //   return;
    // }

    createEDDA(localPolicyNo, localProduct, localPremium, bankID,4,localOrderNo,0,checkedA);
  };

  onClickHere = () => {
    ReactGA.event({
      category: "RenewalPages",
      action: "Back to Login",
    });
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  handleChangeCheckedA = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  renderChildren = () => {
    const { classes } = this.props;
    const {
      policyNo,
      productName,
      startDate,
      endDate,
      renewalPremium,
    } = policyInfo;
    const {
      localPolicyNo,
      localOrderNo,
      localNric,
      localPremium,
      localIsRecurring,
      localCoveragePeriod,
      localProduct,
      localStatusLabel,
      localMsg,
      loadingToReddot,
      localOwnerName,
    } = this.state;
    return (
      <Grid
        container
        direction={"column"}
        spacing={2}
        style={{ marginTop: window.innerWidth < 600 ? "-2em" : false }}
      >
        <CustomText
          design={classes.renewNowTextStyle}
          style={{ color: "#2c3034" }}
        >
          GI Policy Renewal
        </CustomText>

        <CustomText
          design={classes.renewNowSecTextStyle}
          style={{ color: "#2c3034", marginTop: 15, fontSize: "18px" }}
        >
          Renewal Details
        </CustomText>

        {/* {localStatusLabel === "Repurchase Now" ? (
          <Grid item>
            <CustomText design={classes.labelTextInputTextStyle}>
              Your policy has expired.
            </CustomText>
            <CustomText design={classes.labelTextInputTextStyle}>
              Proceed to start your coverage now.
            </CustomText>
          </Grid>
        ) : (
          <Grid item>
            <CustomTextInput
              title={"Policy Number"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={localPolicyNo}
              disabled={true}
            />
          </Grid>
        )} */}

        <Grid
          container
          direction={"row"}
          style={{ justifyContent: "flex-start", marginBottom: 30 }}
        >
          <Grid style={{ marginTop: "0.75rem", width: "200px" }}>
            Policy No.
          </Grid>
          <Grid>
            <CustomTextInput
              // title={"Policy Number"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={localPolicyNo}
              disabled={true}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction={"row"}
          style={{ justifyContent: "flex-start", marginBottom: 30 }}
        >
          <Grid style={{ width: "200px" }}>Policy Owner’s Name</Grid>
          <Grid style={{ fontWeight: "bold",fontStyle:"italic" }}>{localOwnerName}</Grid>
        </Grid>
       

        <Grid
          container
          direction={"row"}
          style={{ justifyContent: "flex-start", marginBottom: 30 }}
        >
          <Grid style={{ width: "200px" }}>Product Name</Grid>
          <Grid style={{ fontWeight: "bold",fontStyle:"italic" }}>{localProduct}</Grid>
        </Grid>

        <Grid
          container
          direction={"row"}
          style={{ justifyContent: "flex-start", marginBottom: 30 }}
        >
          <Grid style={{ width: "200px" }}>Coverage Period</Grid>
          <Grid style={{ fontWeight: "bold",fontStyle:"italic" }}>{localCoveragePeriod}</Grid>
        </Grid>

        <Grid
          container
          direction={window.innerWidth < 670 ? "column":"row"}
          style={{ justifyContent: "flex-start", marginBottom: 0 }}
        >
          <Grid style={{ width: "200px" }}>Renewal Premium</Grid>
          <Grid style={{ fontWeight: "bold",fontStyle:"italic" }}>{localPremium}</Grid>
        </Grid>

        {/* <Grid item>
          <CustomTextInput
            title={"Product Name"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={localProduct}
            disabled={true}
          />
        </Grid>

        <Grid item>
          <CustomTextInput
            title={"Coverage Period"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            // value={`${startDate} ~ ${endDate}`}
            value={localCoveragePeriod}
            disabled={true}
          />
        </Grid>

        <Grid item>
          <CustomTextInput
            title={"Renewal Premium"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={localPremium}
            disabled={true}
          />
        </Grid> */}

        {loadingToReddot ? <LoadingOverlay loading={true} /> : false}
      </Grid>
    );
  };

  useOutlinedInputStyles = makeStyles((theme) => ({
    root: {
      "& $notchedOutline": {
        borderColor: "red",
      },
      "&:hover $notchedOutline": {
        borderColor: "blue",
      },
      "&$focused $notchedOutline": {
        borderColor: "green",
      },
    },
    focused: {},
    notchedOutline: {},
  }));

  handleChange = (event) => {
    this.setState({ bankID: event.target.value });
  };

  

  renderChildrenSecondPart = () => {
    const { classes } = this.props;
    const {
      policyNo,
      productName,
      startDate,
      endDate,
      renewalPremium,
    } = policyInfo;
    const {
      localPolicyNo,
      localOrderNo,
      localNric,
      localPremium,
      localIsRecurring,
      localCoveragePeriod,
      localProduct,
      localStatusLabel,
      localMsg,
      loadingToReddot,
      isCheckCreditCard,
      isCheckDebitCard,
    } = this.state;
    const outlinedInputClasses = this.useOutlinedInputStyles;
    return (
      <Grid
        container
        direction={"column"}
        spacing={2}
        style={{ marginTop: window.innerWidth < 600 ? "-2em" : false }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <CustomText
            design={classes.renewNowSecTextStyleSecond}
            style={{ color: "#424143", fontSize: "22px", marginTop: -8 }}
          >
            Payment Method
          </CustomText>
          {/* <CustomText
            design={classes.renewNowSecTextStyleSecond}
            style={{ color: "#6d6c6e", fontWeight: "400" }}
          >
            Select an additional payment
          </CustomText> */}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            border: "0.8px solid #d8d8d8",
            borderRadius: "8px",
            paddingTop: 3,
            marginTop: 10,
          }}
        >
          {" "}
          <div>
            {" "}
            <CustomRadioButton
              checked={isCheckCreditCard}
              onChange={this.handleCheckCreditCard}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
          >
            <div>
              {" "}
              <img
                src={Image.creditCardL}
                style={{ width: 45, height: 40 }}
              />
            </div>
            <div style={{ marginTop: 9, marginLeft: 5 }}>Credit Card</div>
          </div>
        </div>
       {this.state.localIsEddaAllow &&
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            border: "0.8px solid #d8d8d8",
            borderRadius: "8px",
            paddingTop: 3,
            marginTop: 15,
          }}
        >
          {" "}
          <div>
            {" "}
            <CustomRadioButton
              checked={isCheckDebitCard}
              onChange={this.handleCheckDebitCard}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <div>
                {" "}
                <img
                  src={Image.dDebit}
                  style={{ width: 40, height: 36,marginLeft:5 }}
                 
                />
              </div>
              <div style={{ marginTop: 9, marginLeft: 5 }}>Direct Debit</div>
            </div>

            {this.state.isCheckDebitCard && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  marginTop: 10,
                  color: "#6d6c6e",
                  fontSize: "14px",
                }}
              >
                Select from the following secure payment methods
              </div>
            )}

            {this.state.isCheckDebitCard && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  marginBottom: 20,
                }}
              >
                <FormControl
                  className={classes.formControl}
                  style={{ width: "100%", fontFamily: "Muli" }}
                >
                  <Select

                    value={this.state.bankID === "" ? 0 : this.state.bankID}
                    onChange={this.handleChange}
                    style={{
                      height: 45,
                      fontFamily: "Muli",
                      fontWeight: "bold",
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                    displayEmpty
                    placeholder={"DBS/POSB"}
                  >
                    <MenuItem value={0}>Please Select</MenuItem>
                    {console.log("asdasd", this.state.localBankList)}
                    {this.state.localBankList.length > 0
                      ? this.state.localBankList.map((item, index) => {
                          return (
                            <MenuItem value={item.bankCode} key={index}>
                              {item.bankName}
                            </MenuItem>
                          );
                        })
                      : false}
                  
                  </Select>
                </FormControl>
              </div>
            )}
          </div>
        </div>}

        {this.state.localShowRecurringCheckBox === true ? (
          <Grid item>
            <FormControlLabel
            style={{marginRight:0}}
              control={
                <Checkbox
                  //  {...(item.Value === "1" ?  setState({checkedA:true})  : )}
                  checked={this.state.checkedA}
                  onChange={this.handleChangeCheckedA}
                  name="checkedA"
                  color="primary"
                  // classes={{
                  //   root: classes.root,
                  //   checked: classes.checked,
                  // }}
                />
              }
              label={
                <span style={{ fontWeight: "bold", fontFamily: "Muli",fontSize:"0.80rem" }}>
                 Opt in for auto-renewal so you need not worry about policy lapses.
                </span>
              }
            />
          </Grid>
        ) : (
          false
        )}
        {this.state.localShowRecurringCheckBox === true ? (
          <Grid item style={{ marginTop: "-3%",marginLeft:"6%" }}>
            <CustomText design={classes.optTextStyle}>
              By submitting this payment, you agree to the auto-renewal of your
              policy. The subsequent monthly or annual premiums will be charged
              to your selected credit/debit card. If you do not wish to have
              your policy automatically renewed, please un-check the box to opt
              out. If you do so, the auto-renewal will not be available to you
              until th next payment.
            </CustomText>
          </Grid>
        ) : (
          false
        )}
        {/* {this.state.localShowRecurringCheckBox !== true ? (
          <Grid item>
            <CustomText design={classes.optTextStyle}>
              If you do not wish to have your policy automatically renewed,
              please un-check the box to opt out. If you do so, the,
              auto-renewal will not be available to you until the next payment.
            </CustomText>
          </Grid>
        ) : (
          false
        )} */}

        <Grid item>
          <CustomButton
            title={"Let's go!"}
            design={classes.letGoButtonStyle}
            textstyle={classes.buttonTextStyle}
            onClick={this.onClickLetGo}
            id={"renewalToReddotPayment"}
          />
        </Grid>
        {this.state.localShowRecurringCheckBox === false ? (
          <Grid item>
            <CustomText design={classes.bottomTextStyle} component="div">
              For personal clients, you may log in to your account{" "}
              <CustomText
                display={"inline"}
                design={classes.highLightedTextStyle}
                onClick={this.onClickHere}
              >
                here
              </CustomText>{" "}
              to use your eWallet credits.
            </CustomText>
          </Grid>
        ) : (
          false
        )}
        {loadingToReddot  ? <LoadingOverlay loading={true} /> : false}
        {/* {getGIROBankListLoading  ? <LoadingOverlay loading={true} /> : false}
        {createEDDALoading  ? <LoadingOverlay loading={true} /> : false} */}
        
      </Grid>
    );
  };

  handleCheckCreditCard = () => {
    this.setState({
      isCheckCreditCard: !this.state.isCheckCreditCard,
      isCheckDebitCard: false,
    });
  };

  handleCheckDebitCard = () => {
    this.setState({
      isCheckDebitCard: !this.state.isCheckDebitCard,
      isCheckCreditCard: false,
    });
  };

  render() {
    const { classes,loadingToReddot,getGIROBankListLoading,createEDDALoading } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoardNewRenewal
          children={this.renderChildren()}
          childrenSecond={this.renderChildrenSecondPart()}
          height={window.innerWidth < 600 ? "115vh" : "132vh"}
          width={width}
        />
               {loadingToReddot  ? <LoadingOverlay loading={true} /> : false}
        {getGIROBankListLoading  ? <LoadingOverlay loading={true} /> : false}
        {createEDDALoading  ? <LoadingOverlay loading={true} /> : false}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
    "&$checked": {
      color: "#1858b9",
    },
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 5,
  },
  letGoButtonStyle: {
    width: 120,
    marginTop: 10,
    //marginBottom:"1em"
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 10,
  },
  renewNowSecTextStyle: {
    ...getFontWeight("800"),
    fontSize: 24,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 10,
  },
  renewNowSecTextStyleSecond: {
    ...getFontWeight("800"),
    fontSize: 14,
    textAlign: "left",
    // color: "#424143",
    marginBottom: 10,
  },
  errorTextStyle: {
    color: "red",
  },

  checked: {},
  optTextStyle: {
    fontSize: 13,
    opacity: 0.7,
  },
});

function mapStateToProps(state) {
  return {
    checkRenewabilityData: selector.checkRenewabilityData(state),
    checkRenewabilityLoading: selector.checkRenewabilityLoading(state),
    checkRenewabilityStatus: selector.checkRenewabilityStatus(state),
    renewalPayNowData: selector.renewalPayNowData(state),
    renewalPayNowLoading: selector.renewalPayNowLoading(state),
    renewalPayNowStatus: selector.renewalPayNowStatus(state),

    createEDDAData: selector.createEDDAData(state),
    createEDDALoading: selector.createEDDALoading(state),
    createEDDAStatus: selector.createEDDAStatus(state),
    getDDAPolicyData: selector.getDDAPolicyData(state),
    getDDAPolicyLoading: selector.getDDAPolicyLoading(state),
    getDDAPolicyStatus: selector.getDDAPolicyStatus(state),
    getGIROBankListData: selector.getGIROBankListData(state),
    getGIROBankListLoading: selector.getGIROBankListLoading(state),
    getGIROBankListStatus: selector.getGIROBankListStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    checkRenewability: (submitData) =>
      dispatch(onlineRenewalAction.checkRenewability(submitData)),
    renewalPayNow: (premium, orderNo, nric, policyNo, isRecurring) =>
      dispatch(
        onlineRenewalAction.renewalPayNow(
          premium,
          orderNo,
          nric,
          policyNo,
          isRecurring
        )
      ),

    createEDDA: (policyNumber, policyName, premium, bankID, transactionType,orderNumber,
      ewalletAmount,
      isRecurring) =>
      dispatch(
        enrolGIRONowAction.createEDDA(
          policyNumber,
          policyName,
          premium,
          bankID,
          transactionType,orderNumber,
          ewalletAmount,
          isRecurring
        )
      ),
    getGIROBankList: (transactionType) =>
      dispatch(enrolGIRONowAction.getGIROBankList(transactionType)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(PolicyInfo)));
